<template>
  <div>
    <vxe-modal
    v-model="ResourceCenterDialogVisible"
    :before-hide-method="closeDialog"
    width="80%"
    height="90%"
    show-zoom
    resize
    transfer
    >
        <template #title>
            <span>资源中心</span>
        </template>
        <template #default>
            <Resource_center
            v-if="ResourceCenterDialogVisible"
            ref="ResourceCenter"
            @handle-confirm="handleConfirm"
            @close-dialog="closeDialog"
            @handle-cancel="handleCancel"
            v-model:itemParam.sync="itemParam"
            >
            </Resource_center>
        </template>
    </vxe-modal>
  </div>
</template>
<script>
import Resource_center from './resource_center.vue';
export default {
  name: "resourceNew",
  data() {
    return {
      itemParam:{
        type:['1','2','3','4'],//显示的类型
        selectId:[],//选中的资源的id集合,
        isSingle:false,//是否单选
        source:"SubResourceCenter",//文件来源
        row:{},//操作行的对象
        sourceItem:{},//资源文件对象
      },
    };
  },
  props: {
    ResourceCenterDialogVisible: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Resource_center,
  },
  created() {},
  methods: {
    loading(param){
      //debugger
      var _this = this
      setTimeout(() => {
          _this.$refs.ResourceCenter.loading(param)
      }, 100);
    },
    handleConfirm(obj){
      this.$emit("handle-confirm",obj);
    },
    closeDialog() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
  },
  computed: {

  },
};
</script>
<style scoped>
.resourceNew {
  background-color: #fff;
  padding: 0 10px 10px 10px;
}
.resourceNew .top-tabs :deep(.el-tabs__nav-scroll) {
  margin-left: 20px;
}

:deep(.resourceList .resource-content_pagination){
  position: fixed;
  bottom: 10%;
  right: 12%;
};
</style>